import React from 'react';
import SubscriptionTabWithGroupedProducts from './subscription-tab-with-grouped-products';
import SubscriptionTab from './subscription-tab';
import { SubscriptionTabProps } from '../../../common-types';
import { useFeatureToggle } from '@css-xp/base';
import { ENABLE_ENTITLEMENT_RELATIONSHIP_FEATURE } from '@atlassian/cssxp-utils-generic';

const SubscriptionTabIndex = (props: SubscriptionTabProps) => {
  const [isEnabled] = useFeatureToggle();

  if (isEnabled(ENABLE_ENTITLEMENT_RELATIONSHIP_FEATURE)) return <SubscriptionTabWithGroupedProducts {...props} />;

  return <SubscriptionTab {...props} />;
};

export default SubscriptionTabIndex;
